import React, { useMemo } from 'react';
import { ExarePriceDetailsPriceElementType } from '@websky/graphql';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../../theme';
import PriceItem from '../PriceItem/PriceItem';
import TotalRefund from '../TotalRefund/TotalRefund';
import { getTotalPriceFilteredElements, getZeroPrice } from '@shared/lib/money';
const ShortDetails = ({ prices, ticketPrice, className }) => {
    const { t } = useTranslation('Refund');
    const { ShortDetails: css } = useTheme('Entities').Order.ExchangeRefundPriceDetails;
    const details = useMemo(() => {
        var _a;
        const items = [];
        const priceDetails = prices.priceDetails;
        const currentCurrency = (_a = prices.basePrice) === null || _a === void 0 ? void 0 : _a.currency;
        items.push({
            name: `${t('Ticket price')}:`,
            price: prices.basePrice || getZeroPrice(currentCurrency)
        });
        items.push({
            name: t('Cost of refundable services'),
            price: getTotalPriceFilteredElements(priceDetails.refunded.elements, ExarePriceDetailsPriceElementType.gdsServiceFare, currentCurrency)
        });
        items.push({
            name: t('Cost of non-refundable services'),
            price: getTotalPriceFilteredElements(priceDetails.retention.elements, ExarePriceDetailsPriceElementType.gdsServiceFare, currentCurrency),
            isMinus: true
        });
        items.push({
            name: t('Fare refund penalty'),
            price: getTotalPriceFilteredElements(priceDetails.retention.elements, ExarePriceDetailsPriceElementType.taxesRetention, currentCurrency),
            isMinus: true
        });
        return items;
    }, [t, prices, ticketPrice]);
    return (React.createElement("div", { className: cn(css.root, className) },
        React.createElement("div", { className: css.details }, details.length > 0 &&
            details.map((detail, index) => (React.createElement(PriceItem, { key: index, className: css.item, name: detail.name, price: detail.price, isMinus: detail.isMinus })))),
        React.createElement(TotalRefund, { className: css.totalRefund, price: prices.priceToPay })));
};
export default ShortDetails;
